import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from "primereact/tabview";
import { Fetch } from "../../shared/Fetch";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";


interface Iprops {
  open: boolean;
  hideDialog: () => void;
  teamId: number;
}

export const TeamHistoryModal = (props: Iprops) => {

  const [managerHistory, setManagerHistory] = useState<any[]>([]);
  const [memberHistory, setMemberHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const loadHistory = async () => {
    setLoading(true);

    const managerResp = await Fetch("Team_Mast/teamHistory", "GET", null, `team_ID=${props.teamId}`, null);
    const memberResp = await Fetch("TeamMember_Mast/teamMemberHistory", "GET", null, `team_ID=${props.teamId}`, null);

    if (managerResp) setManagerHistory(await managerResp.json());
    if (memberResp) setMemberHistory(await memberResp.json());

    setLoading(false);
  };

  useEffect(() => {
    if (props.open && props.teamId) {
      loadHistory();
    }
  }, [props.open, props.teamId]);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj?.date_Format;

  return (
    <Dialog visible={props.open} style={{ width: "75vw" }} header="Team History" modal className="p-fluid" onHide={props.hideDialog} >
      <TabView>
        <TabPanel header="Manager History">

          <DataTable value={managerHistory} loading={loading} stripedRows showGridlines responsiveLayout="scroll" emptyMessage="No Manager History Found" >
            <Column header="SN." body={(d, o) => o.rowIndex + 1} style={{ width: "40px" }} />
            <Column field="manager_Name" header="Manager Name" sortable />
            <Column field="created_On" header="Assigned On" sortable body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DateFormat)} />
          </DataTable>
        </TabPanel>

        <TabPanel header="Member History">
          <DataTable value={memberHistory} loading={loading} stripedRows showGridlines responsiveLayout="scroll" rowClassName={(rowData) => rowData.is_Current ? "active-row" : ""} emptyMessage="No Member History Found" >
            <Column header="SN." body={(d, o) => o.rowIndex + 1} style={{ width: "40px" }} />
            <Column field="member_Name" header="Member Name" sortable />
            <Column field="in_Team_Date" header="Joined On" sortable body={(rowData: any) => safeFormatDate(rowData.in_Team_Date, "dd/MM/yyyy", DateFormat)} />
            <Column field="out_Team_Date" header="Left On" body={(rowData: any) => safeFormatDate(rowData.out_Team_Date, "dd/MM/yyyy", DateFormat)} />
          </DataTable>
        </TabPanel>

      </TabView>
    </Dialog>
  );
};
